import type { ThemeConfig } from 'antd'

export const adminTheme: ThemeConfig = {
  token: {
    colorPrimary: '#171717',
    colorPrimaryHover: '#333333',
    colorPrimaryActive: '#000000',
    colorInfo: '#0070F3',
    colorSuccess: '#087A68',
    colorWarning: '#A65A00',
    colorError: '#D40000',
    colorBgBase: '#FFFFFF',
    colorBgLayout: '#FAFAFA',
    colorBgContainer: '#FFFFFF',
    colorBgElevated: '#FFFFFF',
    colorBorder: '#EBEBEB',
    colorBorderSecondary: '#F0F0F0',
    colorSplit: '#EBEBEB',
    colorText: '#171717',
    colorTextSecondary: '#4D4D4D',
    colorTextDescription: '#666666',
    colorLink: '#0070F3',
    colorLinkHover: '#0761D1',
    colorLinkActive: '#004EAE',
    borderRadius: 6,
    borderRadiusLG: 12,
    controlHeight: 40,
    fontFamily: 'Geist, Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    fontSize: 14,
    lineWidth: 1,
    motionDurationMid: '0.2s',
    wireframe: false,
  },
  components: {
    Alert: { borderRadiusLG: 8, withDescriptionPadding: '16px 20px' },
    Button: {
      borderRadius: 6,
      controlHeight: 40,
      defaultBorderColor: '#D8D8D8',
      defaultColor: '#171717',
      primaryShadow: '0 1px 1px rgba(0, 0, 0, 0.08), 0 2px 8px rgba(0, 0, 0, 0.06)',
    },
    Card: {
      borderRadiusLG: 12,
      boxShadowTertiary: '0 0 0 1px rgba(0, 0, 0, 0.04), 0 1px 1px rgba(0, 0, 0, 0.03), 0 8px 24px -16px rgba(0, 0, 0, 0.18)',
      headerBg: '#FFFFFF',
    },
    Drawer: { colorBgElevated: '#FFFFFF' },
    Input: { activeBorderColor: '#171717', hoverBorderColor: '#A1A1A1' },
    Layout: { bodyBg: '#FAFAFA', headerBg: 'rgba(255, 255, 255, 0.88)', siderBg: '#111111' },
    Menu: {
      darkItemBg: '#111111',
      darkSubMenuItemBg: '#0A0A0A',
      darkItemColor: 'rgba(255, 255, 255, 0.72)',
      darkItemHoverColor: '#FFFFFF',
      darkItemHoverBg: '#242424',
      darkItemSelectedBg: '#FFFFFF',
      darkItemSelectedColor: '#171717',
      itemColor: '#333333',
      itemHoverColor: '#171717',
      itemHoverBg: '#F5F7FA',
      itemSelectedColor: '#173E7A',
      itemSelectedBg: '#EAF2FF',
      itemBorderRadius: 6,
      itemMarginInline: 10,
    },
    Segmented: { itemSelectedBg: '#FFFFFF', trackBg: '#F0F0F0' },
    Select: {
      activeBorderColor: '#171717',
      hoverBorderColor: '#A1A1A1',
      optionActiveBg: '#F5F7FA',
      optionSelectedBg: '#EAF2FF',
      optionSelectedColor: '#173E7A',
    },
    Table: {
      borderColor: '#EBEBEB',
      headerBg: '#F7F7F7',
      headerColor: '#4D4D4D',
      headerSplitColor: '#E6E6E6',
      rowHoverBg: '#FAFAFA',
      rowSelectedBg: '#EAF2FF',
      rowSelectedHoverBg: '#DCEAFF',
    },
  },
}
